export function naira2kobo(e) {
  let kobo = e * 100
  return kobo
}

export function kobo2naira(e) {
  let kobo = e * 100
  return kobo
}
